import { Wrench } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const serviceManifest: ModuleDefinition = {
  id: 'service',
  name: 'Service',
  icon: <Wrench size={20} />,
  color: 'var(--brand-primary)',
  basePath: '/service',
  status: 'active',
  navItems: [
    { label: 'Dashboard', path: '/service', icon: '' },
    { label: 'Werkorders', path: '/service/werkorders', icon: '' },
    { label: 'Claims', path: '/service/claims', icon: '' },
    { label: 'Onderhoud', path: '/service/onderhoud', icon: '' },
    { label: 'Onderdelen', path: '/service/onderdelen', icon: '' },
    { label: 'Kennisbank', path: '/service/kennisbank', icon: '' },
    { label: 'SLA', path: '/service/sla', icon: '' },
    { label: 'Feedback', path: '/service/feedback', icon: '' },
    { label: 'Zelfservice', path: '/service/zelfservice', icon: '' },
  ],
  component: () => import('./index.js'),
};

export default serviceManifest;
